import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useTenantSignalREvent } from "../../../services/hooks/useTenantSignalR";
import { MessageContext } from '../../../services/Context/MessageContext';

// Loads the unread message count and refreshes it whenever a new message arrives over SignalR.
const useUnreadMessageCount = (signalType) => {
    const { messageCount, getUnreadMessageCount } = useContext(MessageContext);

    useEffect(() => {
        getUnreadMessageCount();
    }, [signalType, getUnreadMessageCount]);

    useTenantSignalREvent(
        "ReceiveEvent",
        (message) => {
            if (message.eventType === "MessageReceived") {
                getUnreadMessageCount();
            }
        },
        "message",
    );

    return messageCount;
};

// Unread count shown on the left-nav Message menu icon (rendered inside .nav_icon_wrap).
export const MessageCountBadge = () => {
    const messageCount = useUnreadMessageCount();

    if (!messageCount) return null;

    return (
        <span className="nav_icon_badge badge rounded-pill">
            {messageCount > 99 ? "99+" : messageCount}
            <span className="visually-hidden">unread messages</span>
        </span>
    );
};

const MessageNotification = (props) => {
    const navigate = useNavigate();
    const messageCount = useUnreadMessageCount(props.signalType);

    const redirectToMessage = () => {
        navigate("/message?rcode=XK8");
    }

    return (
        <>
            <a onClick={() => redirectToMessage()}
                class="pointer-class position-relative text-start me-3 msg-header-link"
            >
                <svg className="msg-header-icon" width="20" height="20" role="img" aria-label="Messages"><use xlinkHref="#svg_message" /></svg>
                {
                    messageCount !== 0 ?
                        <small class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary"
                            style={{
                                padding: '0.3em 0.4em',
                                fontSize: '0.7rem',
                                lineHeight: '1',
                                marginLeft: '2px'
                            }}
                        >{messageCount}<small class="visually-hidden">unread messages</small>
                        </small> : <></>
                }
            </a>
        </>
    );
}

export default MessageNotification;